import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import {
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  ExportButton,
  FilterButton,
  FunctionField,
  List,
  TextField,
  TextInput,
  TopToolbar,
} from 'react-admin';
import { StatusField } from './StatusField';
import MainLayout from '../layout/MainLayout';
import CategoryIcon from '@mui/icons-material/Category';
import { ItemList } from '../item/ItemList';
import { useEffect, useState } from 'react';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid',
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};


const CategoryListActionToolbar = ({ children, ...props }) => (
  <Box sx={{ alignItems: 'center', display: 'flex' }}>{children}</Box>
);
const CategoryListAction = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton label="Create New" sx={saveButton} />
      <ExportButton sx={backButton} />
    </TopToolbar>
  );
};
const categoryFilters = [
  <TextInput
    source="name"
    label="Search by name"
    id="name-filter-category"
    resource="Category"
    alwaysOn={true}
  />,
];


function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width
  };
}

export const CategoryList = () => {
  const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
  const [currentScreenPx, setCurrentScreenPx] = useState('');

  useEffect(() => {
    function handleResize() {
      setCurrentScreen(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setCurrentScreenPx((currentScreen.width - 70) + 'px')
  }, [currentScreen])

  return (
    <MainLayout>
      <Grid sx={{ textAlign: 'left' }}>
        <Button
          endIcon={<CategoryIcon sx={{ color: Color.Main }} />}
          sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
          size="medium"
        >
          <Typography variant="h3">Category Management</Typography>
        </Button>
      </Grid>
      <Divider sx={{ width: '100%', mb: 2 }} />
      <List actions={<CategoryListAction />} filters={categoryFilters}>
        <Datagrid
          bulkActionButtons={false}
          rowClick="expand"
          expand={<ItemList />}
          expandSingle
          sx={{
            '& .RaDatagrid-tableWrapper': {
              xs: {
                overflowX: 'scroll',
                width: currentScreenPx,
                overflowY: 'hidden',
                mx: '20px',
                whiteSpace: 'nowrap'
              },
              md: {
                overflowX: 'scroll',
                width: currentScreenPx,
                overflowY: 'hidden',
                mx: '20px',
                whiteSpace: 'nowrap'
              },
              lg: {
                overflowX: 'scroll',
                width: '100%',
                overflowY: 'hidden',
                whiteSpace: 'nowrap'
              },
              xl: {
                overflowX: 'scroll',
                width: '100%',
                overflowY: 'hidden',
                whiteSpace: 'nowrap'
              }
            }
          }}
        >
          <TextField source="name" />
          <TextField source="description" />
          <DateField source="created_at" />
          <FunctionField
            label="SubMerchant Created"
            render={(record) => record.submerchant_created.name}
          />
          <StatusField source="status" />
          <CategoryListActionToolbar>
            <EditButton />
          </CategoryListActionToolbar>
        </Datagrid>
      </List>
    </MainLayout>
  );
};
